import { globalConstants } from "../constants";
import {
  getRequest,
  putRequest,
  postRequest,
  deleteRequest,
} from "../system/server-call";
import responseHandler from "../system/server-response-handler";

async function getAll(gridData, candidateId) {
    const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Activity/all/${candidateId}?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getById(id) {
  return getRequest(
    `Activity/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllList() {
  return getRequest(
    `Activity/list`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getInvoiceByActivityId(id) {
  return getRequest(
    `Activity/invoice/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function deleteById(id) {
    return deleteRequest(
    `Activity/${id}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function create(data) {
    return postRequest(
    `Activity/create`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function update(data) {
    return putRequest(
    `Activity`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function generateInvoice(data, id) {
    return putRequest(
    `Activity/invoice/${id}`,
    data,
    true
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function getAllInvoices(gridData) {
    const orderBy = gridData.orderBy ? gridData.orderBy : "Id desc";
  return getRequest(
    `Activity/invoices?pageNumber=${gridData.pageNumber}&pageSize=${gridData.length}&orderBy=${orderBy}&filterExpression=${gridData.filterExpression}`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

async function acceptedActivity() {
  return getRequest(
    `Activity/acceptedActivity`
  ).then(
    (response) => responseHandler.handleServerResponse(response),
    (error) => responseHandler.handleHTTPResponses(error.response)
  );
}

export const activityService = {
  getAll,
  getById,
  deleteById,
  create,
  update,
  getAllList,
  getInvoiceByActivityId,
  generateInvoice,
  getAllInvoices,
  acceptedActivity
};
